__turbopack_context__.v({
  "MediaRange": "VideoPlayer-module__hd18Sq__MediaRange",
});
